<style lang="scss" scoped>
.row {
    h3 {
        line-height: 1.2;

        @media (min-width: 1024px) {
            line-height: 48px;
        }
    }
}
</style>

<template>
    <div class="row">
        <div class="container-fluid py-40 py-md-56 py-lg-80 bg-accent d-flex align-items-center">
            <div class="container d-flex flex-column flex-md-row align-items-start align-items-md-center">
                <h3 class="text-white d-inline-block mb-16 mb-md-0 mr-56">{{ text }}</h3>
                <a :href="href" class="btn btn-white">{{ btn }} <span class="arrow-right" v-html="svg('arrow-right')" /></a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "pageParts.cta-row",

    props: {
        text: {
            type: String,
            required: true,
            default: ''
        },
        btn: {
            type: String,
            required: true,
            default: '',
        },
        href: {
            type: String,
            required: true,
            default: '',
        },
    }
}
</script>